module.exports = {
	channels: {
		STATUS_UPDATE: "STATUS_UPDATE",
		NEW_MESSAGE: "NEW_MESSAGE",
		START_WHATS: "start_whats",
		START_WHATS_PAIRING: "start_whats_pairing",
		PAIRING_CODE: "pairing_code",
		PAIRING_CODE_ERROR: "pairing_code_error",
		LOGOUT: "logout",
		TOAST: "toast",
		SAVE_SETTINGS: "save_settings",
		LOAD_SETTINGS: "load_settings",
		LOAD_SETTINGS_REPLY: "load_settings_reply",
		SAVE_SETTINGS_REPLY: "save_settings_reply",
		LOG: "log",
		// Novos eventos adicionados:
		SET_INSTANCE_ID: "set_instance_id", // Para definir a instância selecionada
		GET_INSTANCE_LIST: "get_instance_list", // Para solicitar a lista de instâncias
		GET_INSTANCE_LIST_REPLY: "get_instance_list_reply", // Para receber a lista de instâncias do processo principal
		DELETE_INSTANCE: "DELETE_INSTANCE", // Para receber a lista de instâncias do processo principal
		DELETE_INSTANCE_REPLY: "DELETE_INSTANCE_REPLY", // Para receber a lista de instâncias do processo principal
		RENAME_INSTANCE: "rename_instance",
		RENAME_INSTANCE_REPLY: "rename_instance_reply",
		COPY_SETTINGS: "copy_settings",
		COPY_SETTINGS_REPLY: "copy_settings_reply",
		DISCONNECTED_ALL: "disconnected_all",
		RESET_CHATS: "reset_chats",
		DISCONNECT_INSTANCE: "disconnect_instance",
		LOGOUT_INSTANCE: "logout_instance",
		// Adicionar novo canal para notificações de erros de IA
		AI_ERROR: "ai-error",
		AI_ERROR_REPLY: "ai-error-reply",
		GET_STORED_AI_ERRORS: "get-stored-ai-errors",
		GET_STORED_AI_ERRORS_REPLY: "get-stored-ai-errors-reply",
		CLEAR_AI_ERROR: "clear-ai-error",
		CLEAR_ALL_AI_ERRORS: "clear-all-ai-errors",
		CHAT_CLEARED: "chat-cleared",
		UPLOAD_KNOWLEDGE_FILE: "upload-knowledge-file",
		LIST_KNOWLEDGE_FILES: "list-knowledge-files",
		DELETE_KNOWLEDGE_FILE: "delete-knowledge-file",
		DELETE_KNOWLEDGE_STORE: "delete-knowledge-store",
		GET_KNOWLEDGE_STATUS: "get-knowledge-status",
		LIST_GEMINI_STORES: "list-gemini-stores",
		CREATE_GEMINI_STORE: "create-gemini-store",
		DELETE_GEMINI_STORE: "delete-gemini-store",
		LIST_STORE_DOCUMENTS: "list-store-documents",
		UPLOAD_TO_STORE: "upload-to-store",
		DELETE_DOCUMENT: "delete-document",
		SET_ACTIVE_STORE: "set-active-store",
		GET_ACTIVE_STORE: "get-active-store",
		UPLOAD_OPENAI_KNOWLEDGE_FILE: "upload-openai-knowledge-file",
		LIST_OPENAI_KNOWLEDGE_FILES: "list-openai-knowledge-files",
		DELETE_OPENAI_KNOWLEDGE_STORE: "delete-openai-knowledge-store",
		GET_OPENAI_KNOWLEDGE_STATUS: "get-openai-knowledge-status",
		LIST_OPENAI_STORES: "list-openai-stores",
		CREATE_OPENAI_STORE: "create-openai-store",
		DELETE_OPENAI_SPECIFIC_STORE: "delete-openai-specific-store",
		GET_OPENAI_STORE_DETAILS: "get-openai-store-details",
		LIST_OPENAI_STORE_FILES: "list-openai-store-files",
		DELETE_OPENAI_FILE: "delete-openai-file",
		UPLOAD_TO_OPENAI_STORE: "upload-to-openai-store",
		SET_ACTIVE_OPENAI_STORE: "set-active-openai-store",
		GET_ACTIVE_OPENAI_STORE: "get-active-openai-store",
		GET_WHATSAPP_GROUPS: "get-whatsapp-groups",
		GET_SCHEDULED_POSTS: "get-scheduled-posts",
		CREATE_SCHEDULED_POST: "create-scheduled-post",
		UPDATE_SCHEDULED_POST: "update-scheduled-post",
		DELETE_SCHEDULED_POST: "delete-scheduled-post",
		TOGGLE_SCHEDULED_POST: "toggle-scheduled-post",
		EXECUTE_SCHEDULED_POST_NOW: "execute-scheduled-post-now",
		GET_FILTERED_METRICS_BY_PERIOD: "get-filtered-metrics-by-period",
		GET_METRICS_INSTANCE_LIST: "get-metrics-instance-list",
		CRM_GET_LEADS_BY_STAGE: "crm-get-leads-by-stage",
		CRM_MOVE_LEAD: "crm-move-lead",
		CRM_REMOVE_LEAD: "crm-remove-lead",
	},
	deliveryStatuses: {
		FAILED: "failed",
	},
	GEMINI_FILE_SEARCH_SUPPORTED_MODELS: [
		'gemini-2.5-flash',
		'gemini-2.5-pro',
		'gemini-3-pro-preview',
		'gemini-3.1-pro-preview',
		'gemini-3-flash-preview',
		'gemini-3.1-flash-lite-preview',
	],
	GEMINI_THINKING_MODELS: [
		'gemini-3-pro-preview',
		'gemini-3.1-pro-preview',
		'gemini-3-flash-preview',
		'gemini-3.1-flash-lite-preview',
	],
};
